import api from "axios";

export const getAllOptions = async () => {
  const [res] = await Promise.all([
    api.get("/optionals"),
  ]);
  return res.data.payload;
};

export const getAllBrandings = async () => {
  const [res] = await Promise.all([
    api.get("/brandings"),
  ]);
  return res.data.payload;
};

export const getAllBrandingModels = async (branding) => {
  const [res] = await Promise.all([
    api.get(`/brandings/models/${branding}`),
  ]);
  return res.data.payload;
};

export const getAllBrandingModelVersions = async (branding, model) => {
  const [res] = await Promise.all([
    api.get(`/brandings/versions/${branding}/${model}`),
  ]);
  return res.data.payload;
};